require "angular"

app = angular.module("workflow.app")
app.controller("MetadataModalController", require("./MetadataModalController"))
app.directive("metadata", require("./metadata"))
